export { TrustpilotWidget } from "./trustpilot-widget";
